/**
 * Calendar (API)
 *  Calendar関連のAPI
 */
import session from './session'

var uri = process.env.API_ENDPOINT

export default {
  getSchedules(data) {
    if (!data.category) {
      return session.get(uri + '/api/cl/schedule/' + data.year + '/' + data.month + '/' + data.day)
    } else {
      return session.get(
        uri +
          '/api/cl/schedule/' +
          data.year +
          '/' +
          data.month +
          '/' +
          data.day +
          '/' +
          data.category
      )
    }
  },
  getSchedulesOne(data) {
    return session.get(
      uri + '/api/cl/schedule/' + data.year + '/' + data.month + '/' + data.day + '/' + data.uuid
    )
  },
  createSchedules(data) {
    return session.post(uri + '/api/cl/schedule/', data)
  },
  updateSchedules(data) {
    return session.patch(uri + '/api/cl/schedule/', data)
  },
  getGoogleCalendar() {
    return session.get(uri + '/api/cl/getGoogleCalendar/')
  },
  getGaroonCalendar() {
    return session.get(uri + '/api/cl/getGaroonCalendar/')
  },
  getCybozuCalendar() {
    return session.get(uri + '/api/cl/getCybozuCalendar/')
  },
  getMSOfficeCalendar() {
    return session.get(uri + '/api/cl/getMSOfficeCalendar/')
  },
  createGoogleCalendar(data) {
    return session.post(uri + '/api/cl/createGoogleCalendar/', data)
  },
  updateGoogleCalendar(data) {
    return session.patch(uri + '/api/cl/updateGoogleCalendar/', data)
  },
  deleteGoogleCalendar(gcid) {
    return session.delete(uri + '/api/cl/deleteGoogleCalendar/' + gcid + '/')
  },
  createGaroonCalendar(data) {
    return session.post(uri + '/api/cl/createGaroonCalendar/', data)
  },
  updateGaroonCalendar(data) {
    return session.patch(uri + '/api/cl/updateGaroonCalendar/', data)
  },
  deleteGaroonCalendar(grid) {
    return session.delete(uri + '/api/cl/deleteGaroonCalendar/' + grid + '/')
  },
  createCybozuCalendar(data) {
    return session.post(uri + '/api/cl/createCybozuCalendar/', data)
  },
  updateCybozuCalendar(data) {
    return session.patch(uri + '/api/cl/updateCybozuCalendar/', data)
  },
  deleteCybozuCalendar(grid) {
    return session.delete(uri + '/api/cl/deleteCybozuCalendar/' + grid + '/')
  },
  createMSOfficeCalendar(data) {
    return session.post(uri + '/api/cl/createMSOfficeCalendar/', data)
  },
  updateMSOfficeCalendar(data) {
    return session.patch(uri + '/api/cl/updateMSOfficeCalendar/', data)
  },
  deleteMSOfficeCalendar(grid) {
    return session.delete(uri + '/api/cl/deleteMSOfficeCalendar/' + grid + '/')
  },
  createSchedule(data) {
    return session.post(uri + '/api/cl/createSchedule/', data)
  },
  getSchedule(companyHash, email) {
    return session.get(uri + '/api/cl/getSchedule/' + companyHash + '/' + email + '/')
  },
  updateSchedule(data) {
    return session.patch(uri + '/api/cl/updateSchedule/', data)
  },
  deleteSchedule(data) {
    return session.delete(uri + '/api/cl/deleteSchedule/' + data['scheduleId'] + '/')
  },
  autoCreateSchedule(data) {
    return session.post(uri + '/api/cl/autoCreateSchedule/', data)
  },
  getRecommendSchedule(data) {
    console.debug('Calendar API - Request Parameters:', data) // 追加
    return session.post(uri + '/api/cl/get_recommend_schedule_new/', data)
  },
  // EventFile API
  createEventFile(data) {
    return session.post(uri + '/api/cl/event_file/', data)
  },
  getEventFile(id) {
    if (id) return session.get(uri + '/api/cl/event_file/' + id)
    else return session.get(uri + '/api/cl/event_file/')
  },
  updateEventFile(data) {
    return session.patch(uri + '/api/cl/event_file/' + data.pk, data)
  },
  deleteEventFile(id) {
    return session.delete(uri + '/api/cl/event_file/' + id)
  },
  getCalendarEvent(data) {
    return session.get(uri + '/api/cl/get_calendar_event/' + data.updateId + '/' + data.email)
  },
  // EventFileGroup API
  createEventFileGroup(data) {
    return session.post(uri + '/api/cl/event_file_group/', data)
  },
  getEventFileGroup(id) {
    if (id) return session.get(uri + '/api/cl/event_file_group/' + id)
    else return session.get(uri + '/api/cl/event_file_group/')
  },
  updateEventFileGroup(data) {
    return session.patch(uri + '/api/cl/event_file_group/' + data.pk, data)
  },
  deleteEventFileGroup(id) {
    return session.delete(uri + '/api/cl/event_file_group/' + id)
  },
  // EventGroup API
  createEventGroup(data) {
    return session.post(uri + '/api/cl/event_group/', data)
  },
  getEventGroup(id) {
    if (id) return session.get(uri + '/api/cl/event_group/' + id)
    else return session.get(uri + '/api/cl/event_group/')
  },
  updateEventGroup(data) {
    return session.patch(uri + '/api/cl/event_group/' + data.pk, data)
  },
  deleteEventGroup(id) {
    return session.delete(uri + '/api/cl/event_group/' + id)
  },
  sendScheduleEmail(data) {
    return session.post(uri + '/api/cl/send_sch_email/', data)
  },
  getTemporaryEvent(id) {
    return session.get(uri + '/api/cl/temp_event?id=' + id)
  },
  createAndDeleteEvent(data) {
    return session.post(uri + '/api/cl/create_and_delete_event/', data)
  },
  updateEventFromScenarioAny(data) {
    return session.patch(uri + '/api/cl/event_from_scenario_any/', data)
  },
  getEventFromScenarioAny(id) {
    return session.get(uri + '/api/cl/event_from_scenario_any/' + id)
  },
  deleteEventFromScenarioAnyExtra(data) {
    return session.patch(uri + '/api/cl/event_from_scenario_any_extra/', data)
  },
  updateEventScenarios(data) {
    return session.patch(uri + '/api/cl/event_from_scenario_for_vacancy/', data)
  },
  deleteEventScenarios(id) {
    return session.delete(uri + '/api/cl/event_from_scenario_for_vacancy/' + id)
  },
  addEventFromScenarioAny(data) {
    return session.post(uri + '/api/cl/add_event_from_scenario_any/', data)
  },
  createEventFileFromTask(data) {
    return session.post(uri + '/api/cl/event_file_from_task/', data)
  },
  getReminderFromSeeker(id) {
    return session.get(uri + '/api/cl/set_reminder_from_seeker/' + id)
  },
  registReminderFromSeeker(id, data) {
    return session.post(uri + '/api/cl/set_reminder_from_seeker/' + id + '/', data)
  },
  deleteReminderFromSeeker(data) {
    return session.patch(uri + '/api/cl/set_reminder_from_seeker/', data)
  },
  getGoogleDriveAttachmentInfo() {
    return session.get(uri + '/api/cl/get_google_drive_attachment_info/')
  },
  createGoogleDriveAttachmentInfo(data) {
    return session.post(uri + '/api/cl/create_google_drive_attachment_info/', data)
  },
  updateGoogleDriveAttachmentInfo(data) {
    return session.patch(uri + '/api/cl/update_google_drive_attachment_info/', data)
  },
  createGoogleDriveAttachmentFile(data) {
    return session.post(uri + '/api/cl/create_attachment_file_to_google_drive/', data)
  },
  updateGoogleCalendarAttachmentFile(data) {
    return session.post(uri + '/api/cl/attach_file_to_google_calendar/', data)
  },
  deleteNoLinkageCalendars(data) {
    return session.delete(uri + '/api/cl/delete_nolinkage_calendars/', data)
  },
  importSchedule (data) {
    return session.post(uri + '/api/cl/import_schedule/', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/calendar.js